module.exports = __webpack_public_path__ + "img/select-coin.afe88e00.png";